// shape.ts
export const shapeTokens = {
  "shape": {
    "corner": {
      "none": {
        "value": "0px",
        "type": "borderRadius",
        "filePath": "design-tokens/shape.json",
        "isSource": true,
        "original": {
          "value": "0px",
          "type": "borderRadius"
        },
        "name": "ShapeCornerNone",
        "attributes": {
          "category": "shape",
          "type": "corner",
          "item": "none"
        },
        "path": [
          "shape",
          "corner",
          "none"
        ]
      },
      "extraSmall": {
        "value": "4px",
        "type": "borderRadius",
        "filePath": "design-tokens/shape.json",
        "isSource": true,
        "original": {
          "value": "4px",
          "type": "borderRadius"
        },
        "name": "ShapeCornerExtraSmall",
        "attributes": {
          "category": "shape",
          "type": "corner",
          "item": "extraSmall"
        },
        "path": [
          "shape",
          "corner",
          "extraSmall"
        ]
      },
      "small": {
        "value": "8px",
        "type": "borderRadius",
        "filePath": "design-tokens/shape.json",
        "isSource": true,
        "original": {
          "value": "8px",
          "type": "borderRadius"
        },
        "name": "ShapeCornerSmall",
        "attributes": {
          "category": "shape",
          "type": "corner",
          "item": "small"
        },
        "path": [
          "shape",
          "corner",
          "small"
        ]
      },
      "medium": {
        "value": "12px",
        "type": "borderRadius",
        "filePath": "design-tokens/shape.json",
        "isSource": true,
        "original": {
          "value": "12px",
          "type": "borderRadius"
        },
        "name": "ShapeCornerMedium",
        "attributes": {
          "category": "shape",
          "type": "corner",
          "item": "medium"
        },
        "path": [
          "shape",
          "corner",
          "medium"
        ]
      },
      "large": {
        "value": "16px",
        "type": "borderRadius",
        "filePath": "design-tokens/shape.json",
        "isSource": true,
        "original": {
          "value": "16px",
          "type": "borderRadius"
        },
        "name": "ShapeCornerLarge",
        "attributes": {
          "category": "shape",
          "type": "corner",
          "item": "large"
        },
        "path": [
          "shape",
          "corner",
          "large"
        ]
      },
      "extraLarge": {
        "value": "24px",
        "type": "borderRadius",
        "filePath": "design-tokens/shape.json",
        "isSource": true,
        "original": {
          "value": "24px",
          "type": "borderRadius"
        },
        "name": "ShapeCornerExtraLarge",
        "attributes": {
          "category": "shape",
          "type": "corner",
          "item": "extraLarge"
        },
        "path": [
          "shape",
          "corner",
          "extraLarge"
        ]
      },
      "full": {
        "value": "999px",
        "type": "borderRadius",
        "filePath": "design-tokens/shape.json",
        "isSource": true,
        "original": {
          "value": "999px",
          "type": "borderRadius"
        },
        "name": "ShapeCornerFull",
        "attributes": {
          "category": "shape",
          "type": "corner",
          "item": "full"
        },
        "path": [
          "shape",
          "corner",
          "full"
        ]
      }
    }
  }
} as const;

export type ShapeTokens = typeof shapeTokens;
